<lib-signature-field [color]="color" (clickContent)="clickContent.emit(signField)">
  <div *ngIf="active" class="app-sign-field-menu col flex items-center" header>
    <div class="px2 nowrap">{{ 'SIGNATURE.TYPE' | translate }}</div>
    <app-signature-type-select
      [value]="signField.type"
      (typeSelect)="onChangeSignFieldType(signField, $event)"
    ></app-signature-type-select>
  </div>

  <div class="font-small p1 flex items-center">
    <lib-icon [icon]="signField.type | signatureTypeIcon" class="mr1"></lib-icon>
    {{ signer | personFullName }}
  </div>

  <div *ngIf="active" class="app-sign-field-control py1 px2 flex justify-end" footer>
    <lib-button
      icon="delete"
      weight="tertiary"
      class="mr1"
      (click)="deleteSignField.emit(signField)"
    >
      {{ 'COMMON.DELETE' | translate }}
    </lib-button>

    <lib-button icon="check" weight="tertiary" (click)="finishSignFieldEdit.emit(signField)">
      {{ 'COMMON.DONE' | translate }}
    </lib-button>
  </div>
</lib-signature-field>
